/**
 * @fileoverview Navigation icons for the Header. JSON files in
 * `public/icons/Header/`.
 */
export const HEADER_ICONS = {
  aiHeader: '/icons/Header/wired-outline-2511-artificial-intelligence-ai-loop-cycle.json',
  learn: '/icons/Header/wired-outline-36-bulb-hover-blink.json',
  /** Travel tab. Markers: in-reveal (default), hover-roll. */
  travel: '/icons/Header/wired-outline-1008-travel-agency-in-reveal.json',
  sources: '/icons/Header/wired-outline-994-sticky-notes-hover-pinch.json',
  account: '/icons/Header/teofqznt.json',
  /** Settings (account) dropdown row. Markers: in-reveal, hover-mechanic. */
  settings: '/icons/Header/wired-outline-39-cog-hover-mechanic.json',
  dashboard: '/icons/Header/pbkmxonw.json',
  signIn: '/icons/Header/wired-outline-2129-login-hover-pinch.json',
  signOut: '/icons/Header/wired-outline-2185-logout-hover-pinch.json',
} as const;
